import React, { useContext, useState, Fragment } from "react";
import { RoundMinusIcon } from "~/assets/svg/InterfaceIcon";
import { PlusIcon } from "~/assets/svg/MathIcon";
import { ApplyContext } from "~/pages/applyFormMange/ApplyRegContext";
import { useTranslation } from "react-i18next";

const InquiryChoice = ({ card }) => {
	const { t } = useTranslation();
	const { setListByTarget } = useContext(ApplyContext);
	const [options, setOptions] = useState(card.option);

	const handleChange = (e) => {
		setListByTarget({ ...card, title: e.target.value });
	};

	const handleOptionAddFields = (event) => {
		event.preventDefault();
		const values = options;
		values.push("");
		setOptions(values);
		setListByTarget({ ...card, option: values });
	};

	const handleOptionRemoveFields = (event, index) => {
		event.preventDefault();
		const values = options;
		values.splice(index, 1);
		setOptions(values);
		setListByTarget({ ...card, option: values });
	};

	const handleOptionInputChange = (index, event) => {
		const values = options;
		values[index] = event.target.value;
		setOptions(values);
		setListByTarget({ ...card, option: values });
	};

	return (
		<div className="c__form horiz">
			<div className="f__group export-label ">
				<div className="f__control  ">
					<input
						name="inquiryChoice"
						className="c__input f__item"
						placeholder={t(
							"pages.round.RoundReg.Inquiry.content.cardType.InquiryChoice.question"
						)}
						type="text"
						value={card.title}
						onChange={handleChange}
					/>
				</div>
			</div>
			{options.map((o, index) => (
				<Fragment key={index}>
					<div className="f__group  ">
						<div className="f__control-wrap">
							<input
								placeholder={`${t(
									"pages.round.RoundReg.Inquiry.content.cardType.InquiryChoice.option1"
								)}${index + 1}`}
								className="c__input export-input"
								id={"optionName" + index}
								name="optionName"
								value={o}
								onChange={(event) => handleOptionInputChange(index, event)}
							/>
							<button
								type="button"
								className="btn-round-delete"
								onClick={(event) => handleOptionRemoveFields(event, index)}
							>
								<RoundMinusIcon />
							</button>
						</div>
					</div>
				</Fragment>
			))}
			<button
				type="button"
				className="dashed-btn plus-btn"
				onClick={(event) => handleOptionAddFields(event)}
			>
				<PlusIcon />
				{t("pages.round.RoundReg.Inquiry.content.cardType.InquiryChoice.addOption")}
			</button>
		</div>
	);
};

export default InquiryChoice;
